import { atom } from "recoil";
export const MeetingItem = atom({
  key: "meeting-item",
  default: {},
});
